'use strict';

module.exports = {
	isLocalStorageAvailable: function () {
		let localStorageAvailable;
		try {
			window.localStorage;
			localStorageAvailable = true;
		} catch (error) {
			localStorageAvailable = false;
		}
		return localStorageAvailable;
	},
	isCookieAvailable: function () {
		let cookieAvailable;
		if (navigator.cookieEnabled) {
			cookieAvailable = true;
		} else {
			cookieAvailable = false;
		}
		return cookieAvailable;
	}
};


// WEBPACK FOOTER //
// ./src/components/utils/helper/helper-storage-check.js